import React, { Component } from 'react';

class PrintConsentToothReduction extends Component {

    render() {
        const { customer, data } = this.props;

        const now = new Date();

        const month = String(now.getMonth() + 1).padStart(2, '0'); // 01–12
        const year = now.getFullYear(); // 2026

        return (
            <div className="print-page">

                {/* Quốc hiệu */}
                <div className="header">
                    <div className="header-left">
                        Công ty TNHH Anh Nguyễn Beauty
                        <br />
                        Cơ sở KB, CB: Nha khoa CHINGO
                    </div>

                    <div className="header-center">
                        <div className="fw-bold uppercase">
                            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                        </div>
                        <div className="national-sub">
                            Độc lập - Tự do - Hạnh phúc
                        </div>
                    </div>

                    <div className="header-right"></div>
                </div>

                {/* Tiêu đề */}
                <div className="text-center fw-bold uppercase mt-24" style={{ fontSize: 18 }}>
                    GIẤY ĐỒNG Ý MÀI RĂNG
                </div>
                <div className="text-center fw-bold uppercase mt-8">
                    TRONG ĐIỀU TRỊ RĂNG THẨM MỸ
                </div>

                {/* I. Thông tin khách hàng */}
                <div className="mt-24 fw-bold">I. THÔNG TIN KHÁCH HÀNG</div>

                <ul>
                    <li>Họ và tên: .................................................................</li>
                    <li>Ngày sinh: .................................................................</li>
                    <li>
                        CCCD/Hộ chiếu: ..........................
                        &nbsp;&nbsp;Ngày cấp: ..........
                        &nbsp;&nbsp;Nơi cấp: ..........
                    </li>
                    <li>Số điện thoại: .................................................................</li>
                </ul>

                {/* II. Nội dung đồng ý */}
                <div className="mt-24 fw-bold">II. NỘI DUNG ĐỒNG Ý MÀI RĂNG</div>

                <div className="mt-16">
                    Tôi xác nhận rằng:
                </div>

                <ol>
                    <li>
                        Tôi đã được bác sĩ giải thích rõ về việc
                        <b> mài răng là thao tác không thể phục hồi</b>,
                        nhằm tạo khoảng và hình thể phù hợp cho răng thẩm mỹ.
                    </li>
                    <li>
                        Tôi hiểu rằng sau khi mài:
                        <ul>
                            <li>
                                Răng thật <b>không thể trở lại hình dạng ban đầu</b>
                            </li>
                            <li>
                                Có thể xuất hiện ê buốt, nhạy cảm tạm thời hoặc kéo dài
                            </li>
                        </ul>
                    </li>
                    <li>
                        Tôi đồng ý cho bác sĩ thực hiện
                        <b> mài răng theo chỉ định chuyên môn</b>,
                        với mức độ mài phù hợp tình trạng thực tế.
                    </li>
                </ol>

                {/* III. Cam kết & miễn trừ */}
                <div className="mt-24 fw-bold">III. CAM KẾT & MIỄN TRỪ</div>

                <ul>
                    <li>
                        Tôi <b>tự nguyện đồng ý mài răng</b>, không khiếu nại về
                        sau liên quan đến việc răng đã bị mài.
                    </li>
                    <li>
                        Tôi hiểu mài răng là <b>điều kiện bắt buộc</b> để thực hiện răng thẩm mỹ.
                    </li>
                </ul>

                {/* Ký xác nhận */}
                <div className="mt-32 fw-bold text-right">
                    Khách hàng ký xác nhận
                </div>
                <div className="text-right">
                    (Ký - ghi rõ họ tên - ngày …… / …… / ……)
                </div>


                <style>
                    {`
                        @page {
                            size: A4;
                            margin: 1cm 1.2cm 1cm 1.8cm;
                            /* top, right, bottom, left */
                        }

                        @media print {
                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 14pt;
                                line-height: 1.5;
                                color: #000;
                            }

                            .print-page {
                                width: 100%;
                            }

                            .text-center {
                                text-align: center;
                            }

                            .text-right {
                                text-align: right;
                            }

                            .fw-bold {
                                font-weight: bold;
                            }

                            .uppercase {
                                text-transform: uppercase;
                            }

                            .mt-16 { margin-top: 16px; }
                            .mt-24 { margin-top: 24px; }
                            .mt-32 { margin-top: 32px; }

                            ul {
                                margin-left: 20px;
                                padding-left: 10px;
                            }

                            li {
                                margin-bottom: 6px;
                            }
                                
                             /* HEADER TỔNG */
                            .header {
                                display: grid;
                                grid-template-columns: 0.8fr 2fr 0.8fr;
                                align-items: start;
                                margin-bottom: 16px;
                            }

                            /* CỘT TRÁI */
                            .header-left {
                                font-size: 11pt;      /* nhỏ hơn body */
                                line-height: 1.3;
                                text-align: left;
                            }

                            /* CỘT GIỮA – QUỐC HIỆU */
                            .header-center {
                                font-size: 12pt;      /* nhỏ hơn body (14pt) */
                                line-height: 1.35;
                                text-align: center;
                            }

                            /* Gạch dưới khẩu hiệu */
                            .header-center .national-sub {
                                display: inline-block;
                                padding-bottom: 2px;
                                border-bottom: 1px solid #000;
                            }

                            /* RIGHT */
                            .header-right {
                                /* để trống để cân bố cục */
                            }
                        }

                    `}
                </style>
            </div >
        );
    }
}

export default PrintConsentToothReduction;
